module.exports = __webpack_public_path__ + "img/13.3ba6ff1c.jpeg";